"use client";

import { useRouter } from "next/navigation";

import { Button } from "@/src/components/shadcn/ui/button";
import { useErrorLogs } from "@/src/lib/data-fetchers/error-log-fetchers";
import { useRetryReferralExport } from "@/src/lib/data-fetchers/referral-export-fetchers";
import { ErrorType } from "@/src/models/error-log";
import type { Task } from "@/src/models/task";

export function ReferralExportResult({ task }: { task: Task }) {
  const { errorLogs } = useErrorLogs(task.id);
  const retry = useRetryReferralExport(task);
  const router = useRouter();
  const latestError = errorLogs
    .filter((error) => error.normalizedName === ErrorType.REFERRAL_SHEET_EXPORT)
    .sort((a, b) => b.createdAt.localeCompare(a.createdAt))[0];

  return (
    <div className="space-y-3">
      <p className="whitespace-pre-wrap text-sm" role="alert">
        {retry.error?.message ??
          latestError?.errorMessage ??
          "Export failed. Check spreadsheet access, column headers, and referral details."}
      </p>
      <p className="text-sm text-muted-foreground">
        Fix the issue, then retry the export. Completed EHR steps will not run again.
      </p>
      <Button disabled={retry.isPending} onClick={() => retry.mutate(undefined, { onSettled: () => router.refresh() })}>
        {retry.isPending ? "Retrying…" : "Retry"}
      </Button>
    </div>
  );
}
